const Users = {
  path: "",
  redirect: "/user-permission",
  name: "",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/user-permission",
      redirect: "/user-permission",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "User",
      meta: {
        requiresAuth: true,
        activeUrl: "/user-permission",
        parent: "permission",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/user"),
          meta: {
            requiresAuth: true,
            activeUrl: "/user-permission",
            parent: "permission",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "User Detail",
          component: () => import("@/views/pages/user/Detail.vue"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/user-permission",
            parent: "permission",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Users;
